
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 4753","fill":"none"}},[_c('path',{attrs:{"data-name":"Rectangle 2265","d":"M0 0h48v48H0z"}}),_c('g',{attrs:{"stroke":"currentColor","stroke-width":"2.5"}},[_c('path',{attrs:{"data-name":"Path 2353","d":"M43.949 22.005v11.971c0 7.98-2 9.976-9.976 9.976H14.025c-7.976-.003-9.976-1.996-9.976-9.976V14.025c0-7.976 2-9.976 9.976-9.976h2.993c2.993 0 3.651.878 4.788 2.394l2.993 3.99a3.162 3.162 0 003.192 1.6h5.985c7.98-.004 9.973 1.992 9.973 9.972z"}}),_c('path',{attrs:{"data-name":"Path 2354","d":"M16.02 4.049h17.956q5.985 0 5.985 5.985v2.753","stroke-linecap":"round","stroke-linejoin":"round"}})])])])
          )
        }
      }
    